"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorStatusMessages = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const axios_1 = require("axios");
const react_router_1 = require("react-router");
const strings_1 = require("../constants/strings");
const sessionRepository_1 = require("../repositories/sessionRepository");
const routerUtils_1 = require("./routerUtils");
const lexico = new lexico_1.default();
const logger = require('pino')();
const styles = {
    container: {
        width: '100%',
        height: '100%',
        backgroundColor: 'hsl(325, 98%, 33%) ',
        color: '#FFFFFF',
        position: 'fixed',
        top: 0,
        left: 0,
    },
    errorBox: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
    },
    button: {
        padding: '10px 20px',
        backgroundColor: '#FFFFFF',
        color: '#FF69B4',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        marginTop: '20px',
        fontSize: '16px',
    },
};
exports.errorStatusMessages = {
    404: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? strings_1.errorStrings.HSBC_PAGE_NOT_FOUND_HEADER
        : lexico.tr('This page does not exist!'),
    401: lexico.tr('You are not authorized to see this!'),
    403: lexico.tr('You do not have permission to access this resource!'),
    500: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? strings_1.errorStrings.DEFAULT : lexico.tr('Looks like our API is down!'),
};
const goBack = () => {
    void sessionRepository_1.SessionRepository.logout();
    (0, routerUtils_1.savePreLoginRouterState)({
        redirectTo: globalThis.location.pathname,
        redirectParams: globalThis.location.search,
    });
    globalThis.location.href = '/signin/login';
};
const ReactRouterErrorBoundary = () => {
    const error = (0, react_router_1.useRouteError)();
    const location = (0, react_router_1.useLocation)();
    const params = (0, react_router_1.useParams)();
    logger.error({
        error: error instanceof Error ? error.message : 'Unknown error',
        stack: error instanceof Error ? error.stack : undefined,
    });
    // Axios errors
    if (error instanceof axios_1.AxiosError) {
        if (error.response?.status === 403) {
            const isViewConversationRoute = (location.pathname.includes('activity') || location.pathname.includes('approvals')) && params['approvalId'];
            const isViewWalletCardRoute = location.pathname.includes('wallet') && params['taskId'];
            const isViewRequestConversationRoute = location.pathname.includes('requests') && params['requestId'];
            if (isViewConversationRoute || isViewWalletCardRoute || isViewRequestConversationRoute) {
                return (0, jsx_runtime_1.jsx)(react_router_1.Navigate, { to: "/signin/login", replace: true });
            }
            const errorMessage = lexico.tr('You do not have permission to access this resource!');
            return ((0, jsx_runtime_1.jsx)("div", { style: styles['container'], children: (0, jsx_runtime_1.jsxs)("div", { style: styles['errorBox'], children: [(0, jsx_runtime_1.jsx)("h1", { children: errorMessage }), (0, jsx_runtime_1.jsx)("p", { children: error.message }), (0, jsx_runtime_1.jsx)("button", { style: styles['button'], onClick: goBack, children: lexico.tr('Go back to login') })] }) }));
        }
        if (error.response?.status === 401) {
            logger.info('401 error detected, redirecting to login');
            void sessionRepository_1.SessionRepository.logout();
            return (0, jsx_runtime_1.jsx)(react_router_1.Navigate, { to: "/signin/login", replace: true });
        }
    }
    // React Router errors
    if ((0, react_router_1.isRouteErrorResponse)(error) && (error.status === 403 || error.status === 401)) {
        logger.info('Router 403/401 error detected, redirecting to login');
        void sessionRepository_1.SessionRepository.logout();
        return (0, jsx_runtime_1.jsx)(react_router_1.Navigate, { to: "/signin/login", replace: true });
    }
    const errorMessage = (0, react_router_1.isRouteErrorResponse)(error)
        ? exports.errorStatusMessages[error.status] ||
            lexico.tr('Sorry, we are having technical difficulties. Please try again later.')
        : lexico.tr('Sorry, we are having technical difficulties. Please try again later.');
    return ((0, jsx_runtime_1.jsx)("div", { style: styles['container'], children: (0, jsx_runtime_1.jsxs)("div", { style: styles['errorBox'], children: [(0, jsx_runtime_1.jsx)("h1", { children: errorMessage }), (0, jsx_runtime_1.jsx)("p", { children: error instanceof Error ? error.message : String(error) }), (0, jsx_runtime_1.jsx)("button", { style: styles['button'], onClick: goBack, children: lexico.tr('Go back') })] }) }));
};
exports.default = ReactRouterErrorBoundary;
